export const TRACK_CONTROL_POINTS = [
  [-305, 18, 26],
  [-260, 16, 164],
  [-150, 24, 251],
  [-14, 22, 270],
  [116, 28, 231],
  [223, 34, 152],
  [276, 29, 42],
  [273, 20, -76],
  [222, 15, -186],
  [116, 13, -255],
  [-11, 18, -274],
  [-126, 25, -238],
  [-208, 31, -166],
  [-262, 28, -78]
] as const;

export const TRACK_MAX_BANK_RADIANS = Math.PI / 20;

const CAPE_ASTER_BANK_PROFILE = {
  start: 0.072,
  fullStart: 0.105,
  fullEnd: 0.175,
  end: 0.218,
  angle: -TRACK_MAX_BANK_RADIANS,
} as const;

const smoothstep = (value: number): number =>
  value * value * (3 - 2 * value);

export const sampleAuthoredTrackBank = (progress: number): number => {
  const wrapped = ((progress % 1) + 1) % 1;
  const { start, fullStart, fullEnd, end, angle } = CAPE_ASTER_BANK_PROFILE;

  if (wrapped <= start || wrapped >= end) {
    return 0;
  }
  if (wrapped < fullStart) {
    return angle * smoothstep((wrapped - start) / (fullStart - start));
  }
  if (wrapped <= fullEnd) {
    return angle;
  }
  return angle * (1 - smoothstep((wrapped - fullEnd) / (end - fullEnd)));
};

const TRACK_CURVATURE_SAMPLES = [
  0.82, 0.513, 0.405, 0.37, 0.386, 0.468, 0.473, 0.407,
  0.377, 0.377, 0.41, 0.468, 0.394, 0.349, 0.326, 0.323,
  0.396, 0.342, 0.305, 0.281, 0.269, 0.258, 0.284, 0.327,
  0.395, 0.502, 0.427, 0.394, 0.388, 0.409, 0.48, 0.414,
  0.374, 0.356, 0.34, 0.328, 0.372, 0.447, 0.566, 0.536,
  0.427, 0.366, 0.337, 0.354, 0.358, 0.343, 0.353, 0.392,
  0.449, 0.39, 0.361, 0.359, 0.398, 0.436, 0.358, 0.296,
  0.275, 0.364, 0.269, 0.174, 0.267, 0.129, 0.396, 0.716
] as const;

export const sampleAuthoredTrackCurvature = (progress: number): number => {
  const wrapped = ((progress % 1) + 1) % 1;
  const samplePosition = wrapped * TRACK_CURVATURE_SAMPLES.length;
  const firstIndex = Math.floor(samplePosition) % TRACK_CURVATURE_SAMPLES.length;
  const secondIndex = (firstIndex + 1) % TRACK_CURVATURE_SAMPLES.length;
  const alpha = samplePosition - Math.floor(samplePosition);
  const first = TRACK_CURVATURE_SAMPLES[firstIndex] ?? TRACK_CURVATURE_SAMPLES[0];
  const second = TRACK_CURVATURE_SAMPLES[secondIndex] ?? first;
  return first + (second - first) * alpha;
};
